import api, { apiFormData } from './api';
import { API_ENDPOINTS } from './endpoints';

// Serviço para Products
export const productService = {
    // Buscar todos os produtos
    getAllProducts: (params?: any) => api.get(API_ENDPOINTS.PRODUCTS.INDEX, { params }),

    // Buscar um produto específico
    getProductById: (id: number) => api.get(API_ENDPOINTS.PRODUCTS.SHOW(id)),

    // Criar um novo produto
    createProduct: (productData: any) =>
        api.post(API_ENDPOINTS.PRODUCTS.CREATE, productData),

    // Atualizar um produto
    updateProduct: (id: number, productData: any) =>
        api.put(API_ENDPOINTS.PRODUCTS.UPDATE(id), productData),

    // Deletar um produto
    deleteProduct: (id: number) =>
        api.delete(API_ENDPOINTS.PRODUCTS.DELETE(id)),

    // Colocar em primeiro (atualizar available_at para agora)
    bumpAvailableAt: (id: number) =>
        api.put(`/api/admin/products/${id}/up`),

    // Upload de imagem
    uploadImage: async (file: File, folder = 'products') => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folder', folder);
        return apiFormData.post('/api/admin/upload/send', formData);
    }
};
